import UniversityService from './UniversityService';

import axios from 'axios';

class VFairService {
    static hasVfairs() {
        return UniversityService.getCurrentSchoolData().then(data => {
            if (data.id) {
                return axios({
                    method: 'GET',
                    url: `${process.env.VUE_APP_API_URL}vfair?school_id=${data.id}`,
                })
                    .then(result => {
                        if (result.data && result.data.length > 0) {
                            const found = result.data.find(vFair => vFair.active);
                            return found !== undefined;
                        }
                        return false;
                    })
                    .catch(() => {
                        return true;
                    });
            } else {
                return false;
            }
        });
    }
}

export default VFairService;
